var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _circle, _path28, _circle2, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTags(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 169,
    viewBox: "0 0 229 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3385_6743)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3385_6743",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 114,
    width: 162,
    height: 55
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.695 114.39H255.009C256.087 114.39 256.326 115.904 255.301 116.236L94.7467 168.241L104.579 143.522L145.695 114.39Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3385_6743)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 144.59,
    cy: 131.59,
    r: 72.4753,
    transform: "rotate(40.747 144.59 131.59)",
    fill: "url(#paint0_linear_3385_6743)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6639 54.3592L31.2517 79.7011C31.8232 80.9509 33.0274 81.7927 34.3975 81.9001L86.4494 85.9801C87.5493 86.0664 88.4893 85.1971 88.4893 84.0938V42L19.6639 54.3592Z",
    fill: "#0E72ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.573 51.7108V77.059C163.573 79.149 161.879 80.8432 159.789 80.8432H90.3826C89.3377 80.8432 88.4905 79.9961 88.4905 78.9511V42L163.573 51.7108Z",
    fill: "#4793F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6639 54.3593V136.569C19.6639 138.105 20.5925 139.488 22.0141 140.071L92.9585 169.123V77.3121L19.6639 54.3593Z",
    fill: "#4793F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6639 54.3593V95.9865C19.6639 97.5091 20.5765 98.8835 21.9799 99.4743L72.8442 120.886C73.6361 121.22 74.5464 120.979 75.03 120.269C77.4034 116.783 84.0871 105.883 85.8078 91.4369C86.9755 81.6345 92.9585 77.3121 92.9585 77.3121L19.6639 54.3593Z",
    fill: "#2538BF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M163.573 51.7113V136.605C163.573 138.123 162.666 139.494 161.269 140.088L92.9597 169.124V77.3125L163.573 51.7113Z",
    fill: "#0E72ED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M163.573 51.7113V100.432C163.573 100.856 163.299 101.225 162.891 101.34C160.141 102.109 149.574 105.046 140.333 107.328C131.473 109.515 118.343 117.125 114.043 119.706C113.225 120.197 112.185 120.009 111.652 119.216C109.574 116.127 104.665 107.75 101.898 94.0858C99.9382 84.4074 94.7474 77.3125 94.7474 77.3125L163.573 51.7113Z",
    fill: "#2538BF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6644 54.3593L92.959 77.3121C92.959 77.3121 85.1839 82.6932 82.2329 91.4369C78.3021 103.084 71.6055 108.584 70.0491 109.74C69.8399 109.896 69.5899 109.945 69.3367 109.883C66.3375 109.152 46.4101 104.169 34.8596 98.0579C22.3459 91.4369 0 86.1401 0 86.1401C0 86.1401 8.04453 78.1949 10.726 66.7185C13.4075 57.8905 19.6644 54.3593 19.6644 54.3593Z",
    fill: "#E7F1FD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M163.573 51.7113L92.9597 77.3125C92.9597 77.3125 101.004 81.7265 102.792 89.6717C104.524 97.3704 107.935 106.727 113.024 112.922C113.307 113.267 113.798 113.353 114.188 113.134C123.108 108.128 130.085 102.842 149.271 97.2096C168.936 91.4374 166.844 89.0871 180.395 83.8826C180.395 83.8826 171.617 70.2501 169.83 62.3049C168.042 54.3597 163.573 51.7113 163.573 51.7113Z",
    fill: "#A8CCF8"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0566 30H64.1064L63.0815 47L62.0566 30Z",
    fill: "#FFBF39"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0566 64H64.1064L63.0815 47L62.0566 64Z",
    fill: "#FFBF39"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2762 31.374L58.2024 30.6763L63.0816 46.9999L56.2762 31.374Z",
    fill: "#FFBF39"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9607 63.3236L69.8869 62.6259L63.0815 47L67.9607 63.3236Z",
    fill: "#FFBF39"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2762 62.626L58.2024 63.3237L63.0816 47.0001L56.2762 62.626Z",
    fill: "#FFBF39"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9607 30.6764L69.8869 31.3741L63.0815 47L67.9607 30.6764Z",
    fill: "#FFBF39"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1245 34.3712L52.6947 33.0599L62.8894 46.7383L51.1245 34.3712Z",
    fill: "#FFBF39"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M73.084 60.4166L74.6542 59.1053L62.8893 46.7382L73.084 60.4166Z",
    fill: "#FFBF39"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1246 59.6288L52.6949 60.9401L62.8896 47.2617L51.1246 59.6288Z",
    fill: "#FFBF39"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0841 33.5831L74.6543 34.8944L62.8894 47.2615L73.0841 33.5831Z",
    fill: "#FFBF39"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7081 39.2467L48.733 37.48L63.0136 46.8634L47.7081 39.2467Z",
    fill: "#FFBF39"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2942 56.2467L78.3191 54.48L63.0136 46.8634L77.2942 56.2467Z",
    fill: "#FFBF39"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7081 54.7533L48.733 56.52L63.0136 47.1366L47.7081 54.7533Z",
    fill: "#FFBF39"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2942 37.7533L78.3191 39.52L63.0136 47.1366L77.2942 37.7533Z",
    fill: "#FFBF39"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M46 44.929L46.3559 42.9199L63 46.8765L46 44.929Z",
    fill: "#FFBF39"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M79.644 50.833L80 48.824L63 46.8765L79.644 50.833Z",
    fill: "#FFBF39"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M46.356 50.833L46 48.824L63 46.8765L46.356 50.833Z",
    fill: "#FFBF39"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44.929L79.6441 42.9199L63 46.8765L80 44.929Z",
    fill: "#FFBF39"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 35.5,
    r: 9.11,
    stroke: "#FFBF39",
    strokeWidth: 2.5,
    strokeMiterlimit: 3.8637,
    strokeLinejoin: "round",
    strokeDasharray: "2.48 2.48"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M134.192 27.688C135.202 29.1965 135.928 30.9114 136.293 32.756L135.066 32.9986C135.226 33.8066 135.31 34.6428 135.31 35.4999C135.31 36.3571 135.226 37.1933 135.066 38.0013L136.293 38.2439C135.928 40.0885 135.202 41.8034 134.192 43.3119L133.153 42.6165C132.218 44.014 131.014 45.2175 129.617 46.153L130.312 47.1918C128.804 48.2017 127.089 48.9274 125.244 49.2923L125.002 48.0661C124.194 48.2259 123.357 48.3099 122.5 48.3099C121.643 48.3099 120.807 48.2259 119.999 48.0661L119.756 49.2923C117.912 48.9274 116.197 48.2017 114.688 47.1918L115.384 46.153C113.986 45.2174 112.783 44.014 111.847 42.6165L110.808 43.3119C109.798 41.8034 109.073 40.0885 108.708 38.2439L109.934 38.0013C109.774 37.1933 109.69 36.3571 109.69 35.4999C109.69 34.6428 109.774 33.8066 109.934 32.9986L108.708 32.756C109.073 30.9114 109.798 29.1965 110.808 27.688L111.847 28.3834C112.783 26.9859 113.986 25.7824 115.384 24.8468L114.688 23.8081C116.197 22.7982 117.912 22.0725 119.756 21.7076L119.999 22.9338C120.807 22.7739 121.643 22.6899 122.5 22.6899C123.357 22.6899 124.194 22.7739 125.002 22.9338L125.244 21.7076C127.089 22.0725 128.804 22.7982 130.312 23.8081L129.617 24.8468C131.014 25.7824 132.218 26.9859 133.153 28.3834L134.192 27.688Z",
    stroke: "#FFBF39",
    strokeWidth: 2.5,
    strokeMiterlimit: 3.8637,
    strokeLinejoin: "round",
    strokeDasharray: "4.95 4.95"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 35.5,
    r: 17.25,
    stroke: "#FFBF39",
    strokeWidth: 2.5,
    strokeMiterlimit: 3.8637,
    strokeLinejoin: "round",
    strokeDasharray: "7.43 7.43"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6671 0.688761C81.6446 0.315231 81.9415 0 82.3157 0V0C82.6899 0 82.9868 0.315232 82.9644 0.688762L82.3157 11.5L81.6671 0.688761Z",
    fill: "#FFBF39"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6671 22.3112C81.6446 22.6848 81.9415 23 82.3157 23V23C82.6899 23 82.9868 22.6848 82.9644 22.3112L82.3157 11.5L81.6671 22.3112Z",
    fill: "#FFBF39"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2559 2.41579C76.0497 2.10351 76.1492 1.68207 76.4733 1.49497V1.49497C76.7974 1.30786 77.2121 1.43242 77.3794 1.76711L82.2233 11.4543L76.2559 2.41579Z",
    fill: "#FFBF39"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0671 21.1414C87.2345 21.4761 87.6492 21.6006 87.9733 21.4135V21.4135C88.2974 21.2264 88.3969 20.805 88.1907 20.4927L82.2233 11.4543L87.0671 21.1414Z",
    fill: "#FFBF39"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2559 20.4928C76.0497 20.8051 76.1492 21.2265 76.4733 21.4136V21.4136C76.7974 21.6007 77.2121 21.4761 77.3794 21.1415L82.2233 11.4543L76.2559 20.4928Z",
    fill: "#FFBF39"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0671 1.76717C87.2345 1.43248 87.6492 1.30792 87.9733 1.49502V1.49502C88.2974 1.68213 88.3969 2.10357 88.1907 2.41585L82.2233 11.4543L87.0671 1.76717Z",
    fill: "#FFBF39"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8128 6.7937C72.4781 6.62634 72.3536 6.21162 72.5407 5.88755V5.88755C72.7278 5.56348 73.1492 5.46399 73.4615 5.67016L82.5 11.6376L72.8128 6.7937Z",
    fill: "#FFBF39"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5384 17.6049C91.8507 17.8111 92.2722 17.7116 92.4593 17.3875V17.3875C92.6464 17.0635 92.5218 16.6488 92.1871 16.4814L82.5 11.6375L91.5384 17.6049Z",
    fill: "#FFBF39"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8128 16.1149C72.4781 16.2822 72.3536 16.697 72.5407 17.021V17.021C72.7278 17.3451 73.1492 17.4446 73.4615 17.2384L82.5 11.271L72.8128 16.1149Z",
    fill: "#FFBF39"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5384 5.30363C91.8507 5.09746 92.2722 5.19695 92.4593 5.52102V5.52102C92.6464 5.84509 92.5218 6.25981 92.1871 6.42717L82.5 11.271L91.5384 5.30363Z",
    fill: "#FFBF39"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6888 10.6224C71.3152 10.6 71 10.8969 71 11.2711V11.2711C71 11.6453 71.3152 11.9421 71.6888 11.9197L82.5 11.2711L71.6888 10.6224Z",
    fill: "#FFBF39"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3112 10.6224C93.6848 10.6 94 10.8969 94 11.2711V11.2711C94 11.6453 93.6848 11.9421 93.3112 11.9197L82.5 11.2711L93.3112 10.6224Z",
    fill: "#FFBF39"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3385_6743",
    x1: 108.352,
    y1: 195.006,
    x2: 188.075,
    y2: 69.9859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2538BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#2538BF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3385_6743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 229,
    height: 127,
    fill: "white",
    transform: "translate(0 42)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/tags.9e77f8f5da8a367c3c309d86275bb8ea.svg";
export { ForwardRef as ReactComponent };